__turbopack_context__.v({
  "filmStrip": "film-strip-module-scss-module__S3wY9a__filmStrip",
  "grid": "film-strip-module-scss-module__S3wY9a__grid",
  "gridColumn": "film-strip-module-scss-module__S3wY9a__gridColumn",
  "gridContainer": "film-strip-module-scss-module__S3wY9a__gridContainer",
  "gridItem": "film-strip-module-scss-module__S3wY9a__gridItem",
  "image": "film-strip-module-scss-module__S3wY9a__image",
  "imageContainer": "film-strip-module-scss-module__S3wY9a__imageContainer",
  "itemTitle": "film-strip-module-scss-module__S3wY9a__itemTitle",
  "marqueeInner": "film-strip-module-scss-module__S3wY9a__marqueeInner",
  "marqueeText": "film-strip-module-scss-module__S3wY9a__marqueeText",
  "text": "film-strip-module-scss-module__S3wY9a__text",
  "textContainer": "film-strip-module-scss-module__S3wY9a__textContainer",
});
